import { Component, EventEmitter, Output, input } from '@angular/core';

export interface TimeRangeOption {
    id: string;
    label: string;
}

/**
 * Generic pill-group time-range picker — a horizontal row of buttons with the active
 * one filled in brand blue.
 *
 * Ported from Customer Connect's `app-time-range-pill`
 * (customer-connect-console/src/lib/shared/time-range-pill.component.ts), which is the
 * same component the provider and admin dashboards use. The API is unchanged; only the
 * styling is, because that one is written in Tailwind utility classes and this repo has
 * no Tailwind. The rules below are the same design against this repo's tokens.
 *
 * Stateless: pass the active range in, persist it from the output.
 */
@Component({
    selector: 'app-time-range-pill',
    standalone: true,
    templateUrl: './time-range-pill.component.html',
    styleUrls: ['./time-range-pill.component.scss'],
})
export class TimeRangePillComponent {
    readonly selected = input.required<string>();
    readonly ranges = input.required<TimeRangeOption[]>();

    @Output() rangeChange = new EventEmitter<string>();

    /**
     * Fires when a user clicks the pill that is already selected. Purely additive —
     * `rangeChange` still only fires on an actual change. Useful for affordances like
     * re-opening a custom-range picker from its own pill.
     */
    @Output() pillReclick = new EventEmitter<string>();

    pick(id: string): void {
        if (this.selected() === id) {
            this.pillReclick.emit(id);
            return;
        }
        this.rangeChange.emit(id);
    }
}
